export const ACCOUNT_INFO = 'accountInfo';
export const BUSINESS_TYPES = 'businessTypes';
export const COUNTRIES = 'countries';
export const TIME_ZONES = 'timeZones';
export const CURRENCIES = 'currencies';
export const DEBITORS = 'debitors';
export const CREDITORS = 'creditors';
export const MANAGERS = 'managers';
export const MANAGER = 'manager';
export const INVOICE_JOBS = 'invoiceJobs';
export const SUB_USERS = 'subUsers';
export const SUB_USERS_BY_ACCOUNT_ID = 'subUsersByAccountId';
export const MAIN_USER_PACKAGE_PLANS = 'mainUserPackagePlans';
export const SUB_USER_PACKAGE_PLANS = 'subUserPackagePlans';
export const INVOICE_NUMBERS = 'invoiceNumbers';
export const TAX_TYPES = 'taxTypes';
export const SALES_TYPES = 'salesTypes';
export const PAYMENT_METHODS = 'paymentMethod';
export const MEASUREMENT_UNITS = 'measurementUnits';
export const LANGUAGES = 'languages';
export const BANK_DATA = 'bankData';
export const BANK_DATAS = 'bankDatas';
export const JOB_NUMBERS = 'jobNumbers';
export const INVOICE_LANGUAGE = 'invoiceLang';
export const INVOICE_NUMBER = 'invoiceNumber';
export const INVOICE = 'invoice';
export const INVOICE_DRAFTS = 'invoiceDrafts';
export const PARTNERS = 'partners';
export const COST = 'cost';
export const PARTNER = 'partner';
export const BALANCES = 'balances';
export const DEBITOR_BALANCES = 'debitorBalances';
export const CREDITOR_BALANCES = 'creditorBalances';
export const INCOMES_AND_EXPENCES = 'incomesAndExpenses';
export const INCOMES = 'incomes';
export const EXPENSES = 'expenses';
export const REPORTS = 'reports';
export const SUB_USER_ROLES = 'subUserRoles';
export const ROLE_BY_ID = 'roleById';
export const SUB_USER_ROLE_BY_ID = 'subUserRolesById';
export const REPORTS_INCOMES = 'ReportsIncomes';
export const REPORTS_EXPENSES = 'ReportsExpenses';
export const REPORTS_INCOMES_EXPENSES = 'ReportsIncomesExpencesSummary';
export const REPORTS_JOB_NUMBER_SUMMARY = 'ReportsJobNumbersSummary';
export const REPORTS_EXPENSES_SUMMARY = 'ReportsExpensesSummary';
export const PARTNERS_DATA = 'partnersData';
export const REPORTS_TAX_TYPES_SUMMARY = 'ReportsTaxTypesSummary';
export const REPORTS_MEASUREMENT_TYPES_SUMMARY="ReportsMeasurementTypesSummary"
export const REPORTS_BANKS_SUMMARY = 'ReportsBanksSummary';
export const COST_LINES = 'costLines';
export const INVOICE_LINES = 'invoiceLines';
export const REPORTS_DEBITORS = 'ReportsDebitors';
export const REPORTS_CREDITORS = 'ReportsCreditors';
export const INVOICE_LINES_DETAILS = 'invoiceLinesDetails';
export const COST_LINES_DETAILS = 'costLinesDetails';
export const GET_INVOICE_PAYMENT_DETAILS = 'getInvoicePaymentDetails';
export const GET_COST_PAYMENT_DETAILS = 'getCostPaymentDetails';
export const COST_DETAILS = 'costDetails';
export const INVOICE_DETAILS = 'invoiceDetails';
export const INVOICE_PAYMENT_DETAILS = 'invoicePaymentDetails';
export const CREDITOR_BALANCE_INFO_SUMMARY = 'creditorBalanceInfoSummary';
export const DEBITOR_BALANCE_INFO_SUMMARY = 'debitorBalanceInfoSummary';
export const COMPANY_STATISTICS = 'companyStatistics';
